import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Country, SanteMobiliteState } from './types';

export const initialState: SanteMobiliteState = {
  step: 1,
  lastVerifiedStep: 0,
  startDate: null,
  endDate: null,
  destination: null,
  hasFrenchSocialSecurity: null,
  price: null,
  contractReference: null,
  stripeConfigType: null,
  subscriptionId: null,
  requiresSignature: null,
  schoolName: null,
};

const santeMobiliteSlice = createSlice({
  name: 'santeMobilite',
  initialState,
  reducers: {
    // Note : tout changement de date, destination ou réponse sécu invalide le
    // prix actuel pour qu'il soit refetché à la prochaine arrivée sur le step 5
    // (le tarif dépend de ces 3 paramètres + de la règle métier zone 4 forcée
    // pour les non-sécu).
    setStartDate(state, action: PayloadAction<string | null>) {
      if (state.startDate !== action.payload) state.price = null;
      state.startDate = action.payload;
    },
    setEndDate(state, action: PayloadAction<string | null>) {
      if (state.endDate !== action.payload) state.price = null;
      state.endDate = action.payload;
    },
    setDestination(state, action: PayloadAction<Country | null>) {
      const sameDestination =
        state.destination?.id === action.payload?.id;
      if (!sameDestination) state.price = null;
      state.destination = action.payload;
    },
    setHasFrenchSocialSecurity(state, action: PayloadAction<boolean | null>) {
      if (state.hasFrenchSocialSecurity !== action.payload) state.price = null;
      state.hasFrenchSocialSecurity = action.payload;
    },
    setPrice(state, action: PayloadAction<number | null>) {
      state.price = action.payload;
    },
    setContractReference(state, action: PayloadAction<string | null>) {
      state.contractReference = action.payload;
    },
    setStripeConfigType(state, action: PayloadAction<'payment_intent' | null>) {
      state.stripeConfigType = action.payload;
    },
    setSubscriptionId(state, action: PayloadAction<string | null>) {
      state.subscriptionId = action.payload;
    },
    setRequiresSignature(state, action: PayloadAction<boolean | null>) {
      state.requiresSignature = action.payload;
    },
    setSchoolName(state, action: PayloadAction<string | null>) {
      state.schoolName = action.payload;
    },
    nextStep(state) {
      state.step += 1;
    },
    prevStep(state) {
      state.step = Math.max(state.step - 1, 1);
    },
    setStepVerified(state, action: PayloadAction<number>) {
      state.lastVerifiedStep = Math.max(state.lastVerifiedStep, action.payload);
    },
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
    },
    reset(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setDestination,
  setHasFrenchSocialSecurity,
  setPrice,
  setContractReference,
  setStripeConfigType,
  setSubscriptionId,
  setRequiresSignature,
  setSchoolName,
  nextStep,
  prevStep,
  setStepVerified,
  setStep,
  reset,
} = santeMobiliteSlice.actions;

export const santeMobiliteReducer = santeMobiliteSlice.reducer;
